import {
  GET_HAZARD_REPORT_FAIL,
  GET_HAZARD_REPORT_SUCCESS,
  GET_HAZARD_REPROTS_BY_LOCATION,
  GET_HAZARD_REPROTS_BY_LOCATION_FAIL,
  GET_HAZARD_REPROTS_BY_LOCATION_SUCCESS,
  SAVE_HAZARD_EMAIL_FAIL,
  SAVE_HAZARD_EMAIL_SUCCESS,
  SUBMIT_REVIEWD_HAZARD_REPORT_FAIL,
  SUBMIT_REVIEWD_HAZARD_REPORT_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  res: [],
  error: [],
  list: [],
  data: [],
};

const HazardReport = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_HAZARD_EMAIL_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case SAVE_HAZARD_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_HAZARD_REPORT_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case GET_HAZARD_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SUBMIT_REVIEWD_HAZARD_REPORT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case SUBMIT_REVIEWD_HAZARD_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_HAZARD_REPROTS_BY_LOCATION:
      return {
        ...state,
        list: [],
      };
    case GET_HAZARD_REPROTS_BY_LOCATION_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_HAZARD_REPROTS_BY_LOCATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default HazardReport;
